import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const styles = theme => ({
    radio: {
        color: '#0070A2',
        '&$checked': {
            color: '#0070A2',
          },
        height : '35px',
    },
    checked: {},
    root: {
        display: 'flex',
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
    },
});

class RadioButtonsGroup extends React.Component {

  render() {
    const { classes, answers } = this.props;

    return (
      <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          <RadioGroup
            aria-label="poll"
            name="poll"
            className={classes.group}
            onChange={this.props.handleChange}
          >

        {Object.keys(answers).map((value,index) => {
            return (
                <FormControlLabel
                    key = {index}
                    value={answers[value]}
                    control={<Radio classes={{root : classes.radio, checked : classes.checked}} />}
                    label={answers[value]}
                />)
        })
        }
          </RadioGroup>
        </FormControl>
      </div>
    );
  }
}

RadioButtonsGroup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RadioButtonsGroup);